export default "https://cdn-static.gokick.com/assets/0ba7a9ad4dd7229a35aca69ca4183ecb31843a51/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";